'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmojisPlugin;
var _react = require("react");
var _lexical = require("lexical");
var _LexicalComposerContext = require("@lexical/react/LexicalComposerContext");
var _EmojiNode = require("../nodes/EmojiNode");
const emojis = new Map([[':)', ['emoji happysmile', '🙂']], [':D', ['emoji veryhappysmile', '😀']], [':(', ['emoji unhappysmile', '🙁']], ['<3', ['emoji heart', '❤']], ['🙂', ['emoji happysmile', '🙂']], ['😀', ['emoji veryhappysmile', '😀']], ['🙁', ['emoji unhappysmile', '🙁']], ['❤', ['emoji heart', '❤']]]);
function findAndTransformEmoji(node) {
  const text = node.getTextContent();
  for (let i = 0; i < text.length; i++) {
    const emojiData = emojis.get(text[i]) || emojis.get(text.slice(i, i + 2));
    if (emojiData === undefined) continue;
    const [emojiStyle, emojiText] = emojiData;
    let targetNode;
    if (i === 0) {
      targetNode = node.splitText(i + 2)[0];
    } else {
      targetNode = node.splitText(i, i + 2)[1];
    }
    const emojiNode = (0, _EmojiNode.$createEmojiNode)(emojiStyle, emojiText);
    targetNode.replace(emojiNode);
    return emojiNode;
  }
  return null;
}
function textNodeTransform(node) {
  let targetNode = node;
  while (targetNode !== null) {
    if (!targetNode.isSimpleText()) {
      return;
    }
    targetNode = findAndTransformEmoji(targetNode);
  }
}
function useEmojis(editor) {
  (0, _react.useEffect)(() => {
    if (!editor.hasNodes([_EmojiNode.EmojiNode])) {
      throw new Error('EmojisPlugin: EmojiNode not registered on editor');
    }
    return editor.registerNodeTransform(_lexical.TextNode, textNodeTransform);
  }, [editor]);
}
function EmojisPlugin() {
  const [editor] = (0, _LexicalComposerContext.useLexicalComposerContext)();
  useEmojis(editor);
  return null;
}
